import React from 'react';
import { AssetHistory } from '../../components/logistics/AssetHistory';

export const AssetHistoryPage = ({ user }: { user: any }) => (
  <div className="p-4 md:p-6">
    <div className="mb-5">
      <h1 className="text-2xl font-bold text-white mb-1">Suivi Historique des Actifs</h1>
      <p className="text-gray-400 text-sm">Registre complet · Recherche · Filtres · Export · Vue détaillée par actif</p>
    </div>
    <AssetHistory user={user} />
  </div>
);
